import { TableQuery } from '@/typings';
import { get, handleResult, post } from '@/util';
import { isNotEmpty } from '@qsxy/element-plus-react';

export type ConversaionDetail = {
	id: string;
	conversation_id: string;
	conversation_type: string;
	title: string;
	inputs: Record<string, any>;
	status: string;
	introduction: string;
	created_at: number;
};

export type MessageDetail = {
	agent_thoughts: [];
	answer: string;
	conversation_id: string;
	id: string;
	inputs: Record<string, any>;
	message_files: [];
	query: string;
	retriever_resources: [];
	status: string;
};

export const getConversations = (params: { user_id: string; pageNum?: number }, isVisitor: boolean) => {
	if (isVisitor) {
		return new Promise<TableQuery<ConversaionDetail>>((resolve, reject) => {
			get(
				'/rest/chat/getConversations',
				{ user: params.user_id, limit: 3 },
				result =>
					handleResult(
						result,
						// @ts-ignore
						({ data }) => resolve(isNotEmpty(data) ? { content: data.map(item => ({ ...item, title: item.name })), totalPages: data.length } : []),
						reject,
					),
				reject,
			);
		});
	} else {
		return new Promise<TableQuery<ConversaionDetail>>((resolve, reject) => {
			post(
				'/conversation/queryPage',
				params,
				result =>
					handleResult(
						result,
						({ data }) => {
							resolve(isNotEmpty(data) ? data : { content: [], totalPages: 0 });
						},
						reject,
					),
				reject,
			);
		});
	}
};

/** 获取会话历史消息 */
export const getChatMessages = (params: { userId: string; conversationId: string }) => {
	return new Promise<MessageDetail[]>((resolve, reject) => {
		get(
			'/rest/chat/getChatMsgHis',
			params,
			result =>
				handleResult(
					result,
					({ data }) => {
						if (data.status === 404) {
							reject(404);
						} else {
							resolve(isNotEmpty(data) ? data : []);
						}
					},
					reject,
				),
			reject,
		);
	});
	// if (isVisitor) {
	// } else {
	// 	return new Promise<TableQuery<ConversaionDetail>>((resolve, reject) => {
	// 		post(
	// 			'/conversation/getMsginfos',
	// 			params.conversationId,
	// 			result =>
	// 				handleResult(
	// 					result,
	// 					({ data }) => {
	// 						resolve(isNotEmpty(data) ? data : []);
	// 					},
	// 					reject,
	// 				),
	// 			reject,
	// 		);
	// 	});
	// }
};

/** 删除会话 */
export const delConversations = (id: string) =>
	new Promise<{ result: string }>((resolve, reject) => {
		post('/conversation/delById', id, result => handleResult(result, ({ data }) => resolve(data), reject), reject);
	});
